<main id="MainContent" tabindex="-1" class="Main exported-views"  role="main" [bentoBusyLoader]="isGetDataLoading">
  <header class="Main-header item-inline">
      <h1 class="Main-heading-mb-0">Exported Views  </h1>
          <button
        type="button"
        class="btn btn-outline-secondary btn-icon btn-md btn-refresh"
        aria-label="Refresh"
        ngbTooltip="Refresh"
        placement="right"
        (click)="refreshData()"
        >
        Refresh &nbsp; <i class="bento-icon-refresh" aria-hidden="true"></i>
        </button>
    
  </header>
  <div class="Main-body Content"> 
    <bento-alert [items]="alerts"></bento-alert>
    <div  class="mt-20 Actions justify-content-center" >
        <wj-flex-grid
          #flexGrid
          class="DataGrid DataGridFlexScroll width-class widthClass btn-addreport"
          [itemsSource]="data"
          [stickyHeaders]="true"
          [showMarquee]="true"
          [showSort]="true"
          [selectionMode]="'Cell'"
          [autoRowHeights]="true"
          [headersVisibility]="'Column'"
          [headersFocusability]="headersFocusability"
          [virtualizationThreshold]="data.totalItemCount"
          (initialized)="gridInitialized(flexGrid)"
          (keydown)="handleKeyDown(flexGrid, $event)"
          (selectionChanged)="handleSelectionChanged(flexGrid, $event)"
          (sortingColumn)="sortGrid($event.getColumn().binding,$event.getColumn().header)"
          *ngIf="data">        
          <wj-flex-grid-column
            [header]="'File name'"
            [binding]="'exportName'"
            [visible]="true"
            [width]="497"
            [isReadOnly]="true"
            [wordWrap]="true" >
              <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
                <div role="button"  class="sort-table">
                  File name
                   <span class="wj-glyph-up" *ngIf="isExportNameAscending"></span>
                  <span class="wj-glyph-down" *ngIf="isExportNameAscending === null ? false : !isExportNameAscending"></span>
                </div>
              </ng-template>
          </wj-flex-grid-column>
          <wj-flex-grid-column
            [header]="'File date'"
            [binding]="'requestModifiedDate'"
            [visible]="true"
            [width]="197"
            [isReadOnly]="true"
            [wordWrap]="true">
             <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
            <div role="button" class="sort-table">
              File date
                <span class="wj-glyph-up" *ngIf="isExportDateAscending"></span>
              <span class="wj-glyph-down" *ngIf="isExportDateAscending === null ? false : !isExportDateAscending"></span>
            </div>
          </ng-template>
        </wj-flex-grid-column>
        
          <wj-flex-grid-column
          [header]="'Status'"
          [binding]="'reportStatus'"
          [visible]="true"
          [width]="180"
          [isReadOnly]="true"
          [wordWrap]="true">
           <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
            <div role="button"   class="sort-table">
              Status
                <span class="wj-glyph-up" *ngIf="isPendingAscending"></span>
              <span class="wj-glyph-down" *ngIf="isPendingAscending === null ? false : !isPendingAscending"></span>
            </div>
          </ng-template>
        <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
          <span class="bold-text" *ngIf="item.reportStatus != 'IN_PROGRESS'">{{ item.reportStatus }}</span>
            <span class="bold-text" *ngIf="item.reportStatus == 'IN_PROGRESS'">IN PROGRESS</span>
        </ng-template>
        
      </wj-flex-grid-column>
          <wj-flex-grid-column
            [header]="'Action'"
            [width]="250"
            [binding]="'reportStatus'"
            [align]="'center'"
            [visible]="true"
            [isReadOnly]="true">
             <ng-template wjFlexGridCellTemplate [cellType]="'ColumnHeader'">
            <div role="button"  class="sort-table">
              Action
                <span class="wj-glyph-up" *ngIf="isPendingAscending"></span>
              <span class="wj-glyph-down" *ngIf="isPendingAscending === null ? false : !isPendingAscending"></span>
            </div>
          </ng-template>
            <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-item="item">
              <ng-container
                *ngIf="item.reportStatus == 'COMPLETED'; then completeReport; else fallbackReport"
              ></ng-container>
              <ng-template #completeReport>
                <input
                  type="button"
                  class="btn btn-primary"
                  (click)="reportDownload(item.exportName)"
                  value="Download"
                  tabindex="-1"
                />
              </ng-template>
              <ng-template #fallbackReport>
                <span *ngIf="item.reportStatus == 'ERROR'">Error: File unavailable</span>
                <span *ngIf="item.reportStatus != 'COMPLETED' && item.reportStatus != 'ERROR'"></span>
              </ng-template>
            </ng-template>
          </wj-flex-grid-column>
        </wj-flex-grid>
        <div id="liveRegion" aria-live="polite" style="position: absolute; left: -9999px"></div>
      </div>
      <div>
        <bento-pagination
          #pagination
          [page]="data.pageIndex + 1"
          [directionLinks]="true"
          [boundaryLinks]="true"
          [totalItems]="data.totalItemCount"
          [(itemsPerPage)]="data.pageSize"
          (itemsPerPageChange)="onPageSizeChanged($event)"
          (pageChange)="onPageChanged($event)"
        ></bento-pagination>
      </div>
  </div>
</main>